module.exports = __webpack_public_path__ + "img/home.077b11fa.png";